import { render, staticRenderFns } from "./RecordRow.vue?vue&type=template&id=d0db1c10"
import script from "./RecordRow.vue?vue&type=script&lang=js"
export * from "./RecordRow.vue?vue&type=script&lang=js"
import style0 from "./RecordRow.vue?vue&type=style&index=0&id=d0db1c10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports